<template>
  <div class="function-upgrade width-full height-full">
    <div class="function-upgrade-text">
      该功能正在升级，近期开发，敬请期待
      <!--<div class="function-upgrade-icon">-->
        <!--<i class="r2-icon-yyy" style="font-size: 30px;"></i>-->
      <!--</div>-->
      <!--<div class="text-align-center font-14 color-999 margin-top-10">-->
        <!--该功能正在升级，近期开发，敬请期待-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'FunctionUpgrade',
  data () {
    return {
      //
    }
  },
  mounted () {
  },
  methods: {}
}
</script>

<style scoped lang="less">
  .function-upgrade {
    position: relative;
    pointer-events: none;
    .function-upgrade-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);

      font-size: 22px;
      font-weight: 500;
      color: #212530;
      line-height: 30px;

      /*.function-upgrade-icon {*/
        /*color: #ffffff;*/
        /*width:56px;*/
        /*height:56px;*/
        /*line-height:56px;*/
        /*background:rgba(33,37,48,0.15);*/
        /*border-radius: 50%;*/
        /*margin: 0 auto;*/
      /*}*/
    }
  }
</style>
